import { FC, ReactNode, useContext } from 'react'
import s from './Cover.module.sass'
import { ImgContext } from '@shared/ui/Layout/Cover/Cover'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { GetResizedLinkWithCustomSize } from '@shared/ui/Media/MediaImg/helpers/helper'

interface Props {
  children: ReactNode
  className?: string
  alt?: string
}

const CoverMain: FC<Props> = ({ children, className = '', alt: _coverBlurAlt = 'image cover blur' }) => {
  const imgSrc = useContext(ImgContext)
  const { isMobile, designEnv } = useClientResponsive()
  // до client responsive — mobile-first, как в useClientResponsive
  const isMobileLayout = designEnv === 'default' || isMobile

  const coverBlurUrl = GetResizedLinkWithCustomSize(imgSrc, {
    width: 8,
    height: isMobileLayout ? 340 : 8,
  })

  return (
    <main className={`${s.main} ${className}`}>
      <div className={s['main-blur-wrapper']}>
        <div
          className={s['main-blur']}
          style={coverBlurUrl ? { backgroundImage: `url(${coverBlurUrl})` } : undefined}></div>
      </div>

      {children}
    </main>
  )
}

export default CoverMain
